import React from "react";
import { Check, X } from "lucide-react";
import { GAP } from "../../mock/mock";

export default function GapSection() {
  return (
    <section className="bg-[#f3ead9]">
      <div className="max-w-6xl mx-auto px-4 lg:px-8 py-16 md:py-24">
        <p className="eyebrow text-lg text-center">{GAP.eyebrow}</p>
        <div className="mx-auto mt-3 ornament-line" />
        <h2 className="mt-4 font-serif-display text-3xl md:text-5xl leading-tight text-center max-w-4xl mx-auto text-[#1a1a1a]">
          {GAP.heading}
        </h2>

        <div className="mt-12 grid md:grid-cols-2 gap-6">
          <div className="bg-white/70 border border-[#e2d5bb] rounded-2xl p-6 md:p-8 lift">
            <h3 className="font-serif-display text-2xl md:text-3xl text-[#1a1a1a]">{GAP.before.title}</h3>
            <ul className="mt-5 space-y-3">
              {GAP.before.items.map((it) => (
                <li key={it} className="flex items-start gap-3 text-[15px] text-[#1a1a1a]/80">
                  <span className="mt-1 h-5 w-5 rounded-full border border-[#8b1b31]/40 grid place-items-center text-[#8b1b31] shrink-0"><X size={12} /></span>
                  <span>{it}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-[#7a1e2f] text-white rounded-2xl p-6 md:p-8 lift">
            <h3 className="font-serif-display italic text-2xl md:text-3xl">{GAP.after.title}</h3>
            <ul className="mt-5 space-y-3">
              {GAP.after.items.map((it) => (
                <li key={it} className="flex items-start gap-3 text-[15px] text-white/90">
                  <span className="mt-1 h-5 w-5 rounded-full bg-white/15 grid place-items-center text-white shrink-0"><Check size={12} /></span>
                  <span>{it}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <p className="mt-10 max-w-3xl mx-auto text-center text-[15px] md:text-base text-[#1a1a1a]/70 italic">
          {GAP.footer}
        </p>
      </div>
    </section>
  );
}
